import { Component, inject } from '@angular/core';
import { SoftwareSpecificSearchService } from '../../software-specific-search.service';

@Component({
    selector: 'app-privacy-terms-pop-up',
    templateUrl: './privacy-terms-pop-up.component.html',
    styleUrls: ['../soft-ware-request-form-page.component.scss'],
    standalone: false
})
export class PrivacyTermsPopUpComponent {
  public service = inject(SoftwareSpecificSearchService);
}
